import { FeelingColors } from "../../Colors";
import storyStyles from "./week-reflection.module.css"
import styles from "./recurring-causes.module.css";
import { StoryWrapper } from "./StoryWrapper";

export const RecurringCausesStory = ({ story, action, isPaused, config, storyData }) => {
    // A story has the sections to draw. and isUplifted info to figure out if colors should be green or red.
    // if transparentTag, then draw the p that way.
    // if highlightedAnswers, then iterate over the tuples and show them.
    return (
        <StoryWrapper storyName={storyData.component + (storyData.index !== undefined ? storyData.index : '')}
            action={action} isPaused={isPaused}>
            <h1 className={storyStyles.size2}>{storyData.data.heading}</h1>
            {storyData.data.sections.map((section, i) =>
                <div key={i} className={styles.section}>
                    {section.transparentTag &&
                        <p className={styles.headingTag}>{section.transparentTag}</p>
                    }
                    {section.whiteTags && section.whiteTags.map(text =>
                        <p className={styles.whiteTag} style={{ color: storyData.data.isUplifting ? "#19ac7e" : "#d76c58" }} key={text}>
                            {text}
                        </p>
                    )}
                    {section.highlightedAnswers && section.highlightedAnswers.map((answer) =>
                        <div key={answer[0]} style={{ display: "flex" }}>
                            <p
                                className={`${storyStyles.size3} ${styles.greenRedTag}`}
                                style={{ backgroundColor: storyData.data.isUplifting ? FeelingColors.Good : FeelingColors.Unpleasant }}
                            >
                                {answer[0]}
                            </p>
                            <p className={`${storyStyles.size3} ${styles.greenRedTagNumber}`}>
                                {answer[1]}
                            </p>
                        </div>
                    )}
                </div>
            )}
        </StoryWrapper>
    )
}

export const RecurringFeelings = ({ story, action, isPaused, config, storyData }) => {
    let feelingsCount = (storyData.data.pleasant?.length ?? 0) + (storyData.data.unpleasant?.length ?? 0);
    return (
        <StoryWrapper storyName={'recurringFeelings'} action={action} isPaused={isPaused}>
            <h1 className={storyStyles.size2} style={{ marginBottom: "2.5rem" }}>{storyData.data.heading}</h1>
            <div
                className={storyStyles.flexWrapContainer}
                style={{ flexDirection: feelingsCount < 6 ? "column" : 'row', marginBottom: "2.5rem" }}
            >
                {storyData.data.pleasant && <RecurringCauses causes={storyData.data.pleasant} isPleasant={true} />}
                {storyData.data.unpleasant && <RecurringCauses causes={storyData.data.unpleasant} isPleasant={false} />}
            </div>
        </StoryWrapper>
    )
}

const RecurringCauses = ({ causes, isPleasant }) => {
    return causes.map(element =>
        <p
            key={element.cause}
            className={styles.whiteTag}
            style={{ color: isPleasant ? "#19ac7e" : "#d76c58" }}
        >
            {element.cause}&nbsp;&nbsp;{element.count}
        </p>
    )
}
